// ErFavorit: false
// ErLaest: false
// Indhold: "Havde også vagt sidste år..\nVend tilbage"
// NoteId: 114
// OpdaterTid: "2022-01-31T11:19:11.3827028"
// OpretTid: "2022-01-20T10:23:44.3796811"
// ReferenceId: 1000156792
// ReferenceType: "MedlemIdent"
// Titel: "Vagt 24 dec. Hvad gælder?"

export type NoteResponse = {
    ErFavorit: boolean
    ErLaest: boolean
    Indhold: string
    NoteId: number
    OpdaterTid: string
    OpretTid: string
    ReferenceId: number
    ReferenceType: string
    Titel: string
    ReferenceNavn: string
}

export interface INote {
    referenceId?: string
    referenceType: string
    title: string
    content: string
    NoteId: number
}

export type CreateNewNoteType = {
    ReferenceId?: number
    ReferenceType?: string
    Titel?: string
    Indhold?: string
}

export type UpdateNoteType = {
    NoteId: number
    Titel?: string
    Indhold?: string
}

export type DeleteNoteType = {
    NoteId: number
}

export class Note {
    referenceId = ''

    referenceType = ''

    title = ''

    content = ''

    id: number | undefined = undefined

    created: Date | undefined = undefined

    updated: Date | undefined = undefined

    name = ''

    isFavorite = false

    archived = false

    isRead = false

    // Searchables.
    searchable_title = ''

    searchable_content = ''

    searchable_member = ''

    static build(data: NoteResponse): Note {
        const note = new Note()

        note.referenceId = String(data.ReferenceId)
        note.content = data.Indhold
        note.title = data.Titel
        note.referenceType = data.ReferenceType
        note.id = data.NoteId
        note.updated = new Date(data.OpdaterTid)
        note.created = new Date(data.OpretTid)
        note.name = data.ReferenceNavn || ''
        note.isFavorite = data.ErFavorit
        note.archived = data.ErLaest
        note.isRead = data.ErLaest

        // Searchables.
        note.searchable_content = note.content

        note.searchable_title = note.title

        note.searchable_member = note.name

        return note
    }
}

export function mapNotes(data: NoteResponse[]): Note[] {
    return data.map((note) => Note.build(note))
}
